module.exports = __webpack_public_path__ + "img/icon_alim.4abb69f7.svg";